<template>
	<div>
		<KButton
			height="34px"
			width="unset"
			font-weight="400"
			font-size="0.8125rem"
			border-radius="0.25rem"
			title="Exportar"
			margin-left="10px"
			margin-right="10px"
			:icon="{ color: '#8b83ba', size: '18px', type: 'file-text' }"
			@click="openModalExport"
		/>
		<Modal
			v-if="modalActive"
			title="Exportar"
			:is-loading="isLoading"
			@download="exportToExcel($event)"
			@close="modalActive = false"
		/>
	</div>
</template>

<script>
import XlsExport from '../../../services/xls-export';
import Modal from '../modal/payment';
import global from '../../../mixins/global';
import * as ecAxios from '../../../util/ecAxios';
import KButton from '../buttons/Default';

export default {
	components: {
		Modal,
		KButton,
	},
	mixins: [global],
	data() {
		return {
			filters: JSON.parse(localStorage.getItem('filter-cartao')),
			modalActive: false,
			isLoading: false,
			dados: [],
		};
	},
	methods: {
		exportToExcel(data) {
			const filters = JSON.parse(localStorage.getItem('filter-cartao'));
			if (filters.situacao[0] === 11) {
				this.getPaymentsNotListed(data);
			} else {
				this.getCardPayments(data);
			}
		},
		openModalExport() {
			this.modalActive = true;
		},
		async getCardPayments(data) {
			this.isLoading = true;
			this.filters = JSON.parse(localStorage.getItem('filter-cartao'));
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PGTO_CARTAO}`, this.filters)
				.then((response) => {
					if (response.data.error === 0) {
						this.dados = response.data.pagamentos;
						this.exportExel(data);
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
			this.isLoading = false;
		},
		async getPaymentsNotListed(data) {
			this.isLoading = true;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PGTO_CARTAO_DENIED}`;
				const params = {
					status: ['DENIED', 'DENY', 'NOT APPROVED', 'NOT VERIFIED'],
					orderby: 'timestamp',
					direction: 'DESC',
				};
				const response = await ecAxios.connection().post(url, params);
				if (response.data.error === 0) {
					this.dados = response.data.pedidopgtocartao;
					this.exportExel(data);
				} else {
					// eslint-disable-next-line no-throw-literal
					throw new Error(response.data.message);
				}
			} catch (error) {
				this.$buefy.notification.open({
					message: error.message,
					type: 'is-danger',
				});
			}
			this.isLoading = false;
		},
		exportExel(data) {
			const newData = [];
			this.dados.map((item) => {
				const newIndex = {
					'COD. PGTO': item.id,
					'SIT. PGTO': item.situacao,
					'COD. PEDIDO': item.pedido_id,
					NSU: item.payment_nsu,
					'COD. PED. ITG': item.pedido_integracao_id,
					'SIT. PEDIDO': item.pedido_situacao,
					'VLR. PAGO': this.transformToBrl(item.vlrpago),
					'VLR. CAPTURA': this.transformToBrl(item.vlrcaptura),
					'DTA. PAGAMENTO': item.dtpagamento,
					'DTA. CAPTURA': item.dtcaptura,
					'COND. PGTO': item.condpgto_descricao,
					GATEWAY: item.gateway,
					TABELA: item.tabvnd_desc,
					EMPRESA: item.empresa_fantasia,
					CLIENTE: item.nomerazao,
					'CPF/CNPJ': item.cpfcnpj,
				};
				newData.push(newIndex);
				return newIndex;
			});
			let filename = '';
			const xls = new XlsExport(newData);
			if (data.nome !== '') {
				filename = `${data.nome}${data.formato}`;
			} else {
				filename = `${new Date().toLocaleString()}${data.formato}`;
			}
			switch (data.formato) {
				case '.xls':
					xls.exportToXLS(filename);
					break;
				case '.csv':
					xls.exportToCSV(filename);
					break;

				default:
					break;
			}
			this.modalActive = false;
		},
	},
};
</script>

<style scoped>
.container-modal-ex {
	display: flex;
	align-items: center;
}
.xlsformat {
	cursor: pointer;
}
.xlsformat {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 60px;
	height: 30px;
	border: 1px solid #cececea9;
}
.btncancel {
	margin-top: 20px;
	height: 40px;
	margin-right: 15px;
}
.btn-export {
	cursor: pointer;
}
</style>

